import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconLink = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8709 3.28708C12.254 1.90397 14.4965 1.90398 15.8796 3.28708C17.2627 4.67019 17.2627 6.91265 15.8796 8.29575L12.9333 11.242C11.5502 12.6251 9.30773 12.6251 7.92463 11.242C7.68055 10.998 7.68055 10.6022 7.92463 10.3581C8.16871 10.1141 8.56443 10.1141 8.80851 10.3581C9.70346 11.2531 11.1545 11.2531 12.0494 10.3582L14.9957 7.41187C15.8906 6.51692 15.8906 5.06592 14.9957 4.17097C14.1007 3.27601 12.6497 3.27601 11.7548 4.17096L10.2817 5.6441C10.0376 5.88818 9.64185 5.88818 9.39777 5.6441C9.15369 5.40003 9.15369 5.0043 9.39777 4.76022L10.8709 3.28708Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.21924 15.956C6.83613 17.3391 4.59367 17.3391 3.21057 15.956C1.82746 14.5729 1.82746 12.3304 3.21057 10.9473L6.15685 8.00104C7.53996 6.61793 9.78241 6.61793 11.1655 8.00104C11.4096 8.24512 11.4096 8.64085 11.1655 8.88492C10.9214 9.129 10.5257 9.129 10.2816 8.88492C9.38668 7.98997 7.93568 7.98997 7.04073 8.88492L4.09445 11.8312C3.1995 12.7262 3.1995 14.1772 4.09445 15.0721C4.9894 15.9671 6.44041 15.9671 7.33536 15.0721L8.8085 13.599C9.05257 13.3549 9.4483 13.3549 9.69238 13.599C9.93646 13.843 9.93646 14.2388 9.69238 14.4829L8.21924 15.956Z"
      fill="currentColor"
    />
  </SvgIcon>
)
